
import {
    DEX_ESPE_USER_LOADING,
    DEX_ESPE_USER_LOADED,
    DEX_ESPE_USER_ERROR

  } from '../../types/dex';

const INITIAL_STATE = {
    loading: false,
    loaded: false,
    error: "",
    data: [],      
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
         
        case DEX_ESPE_USER_LOADING:
            return {
                ...state,
                loading: true,
                loaded: false,
                data: [], 
                error: "",
            };

        case DEX_ESPE_USER_LOADED:
            return {
                ...state,
                loading: false,
                loaded: true,
                data: action.payload,
                error: "",
            };

        case DEX_ESPE_USER_ERROR:
            return {
                ...state,
                loading: false,
                loaded: false,
                data: [],
                error: action.payload,
            };

        default:
            return state;
    }
}